const profilesActionTypes = {
  FETCH_PROFILE_DETAILS: 'FETCH_PROFILE_DETAILS',
  FETCH_PROFILE_DETAILS_SUCCESS: 'FETCH_PROFILE_DETAILS_SUCCESS',
  FETCH_PROFILE_DETAILS_FAIL: 'FETCH_PROFILE_DETAILS_FAIL',

  FETCH_UPDATE_PROFILE_INFO: 'FETCH_UPDATE_PROFILE_INFO',
  FETCH_UPDATE_PROFILE_INFO_SUCCESS: 'FETCH_UPDATE_PROFILE_INFO_SUCCESS',
  FETCH_UPDATE_PROFILE_INFO_FAIL: 'FETCH_UPDATE_PROFILE_INFO_FAIL',
};

export default profilesActionTypes;
